document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('#header');
    const main = document.querySelector('#main');
    if (header && main) {

        function adaptHeaderHeight() {
            const headerHeight = header.offsetHeight;
            main.style.paddingTop = `${headerHeight}px`;
        }

        adaptHeaderHeight();

        window.addEventListener('resize', adaptHeaderHeight);

    }
});